export default {"src":"/_next/static/media/ic_kosik1.e81deec5.svg","height":20,"width":20};